export default __webpack_public_path__ + "static/title-our-time-0ce63c1c86b5e4dd0bc6c448ae83baa9.svg";